import { Settings } from './settings'
import { store } from '@/store/index'

const useToken = () => {
  const setToken = (token) => {
    localStorage.setItem(Settings.tk, token)
  }

  const getToken = () => {
    const token = localStorage.getItem(Settings.tk)
    return token
  }

  const removeToken = () => {
    if (localStorage.getItem(Settings.tk)) {
      localStorage.removeItem(Settings.tk)
      window.alert('令牌已过期，请重新登录')
      window.location.reload()
      store.dispatch({
        type: 'set_entryGroup',
        payload: undefined
      })
    }
  }

  return {
    setToken,
    getToken,
    removeToken
  }
}
export default useToken